import { Controller } from "@hotwired/stimulus"

// The page header renders into the layout's header slot, which puts it outside the
// builder's DOM. An outlet reaches across that boundary without a global event bus.
export default class extends Controller {
  static targets = ["undo", "redo"]
  static outlets = ["avatar-builder"]

  randomise() { this.avatarBuilderOutlet.randomise() }
  undo() { this.avatarBuilderOutlet.undo() }
  redo() { this.avatarBuilderOutlet.redo() }

  // The builder announces every step it takes; the arrows only mirror it.
  historyChanged({ detail: { canUndo, canRedo } }) {
    this.#enable(this.undoTarget, canUndo)
    this.#enable(this.redoTarget, canRedo)
  }

  // ui/button paints its disabled state from aria-disabled, so the property alone
  // leaves an enabled button looking greyed out.
  #enable(button, enabled) {
    button.disabled = !enabled
    button.setAttribute("aria-disabled", String(!enabled))
  }
}
